import { getCollapseNonWorkingTimeConfig } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
import { isEmpty } from 'lodash';

export const useGetCollapseNonWorkingTimeConfig = (
  tenantId: string,
  enabled = true
) => {
  const { data, status, refetch } = useQuery(
    ['collapse-non-working-time-feature'],
    () => getCollapseNonWorkingTimeConfig(tenantId),
    {
      enabled: enabled && !isEmpty(tenantId),
    }
  );

  return {
    feature: data,
    featureStatus: status,
    fetchFeature: refetch,
  };
};
